const listeners = new Set<(userId: string) => void>();
export const subscribeFocusChanges = (listener: (userId: string) => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };
export const publishFocusRefresh = (userId: string) => { for (const listener of listeners) listener(userId); };
